export default __webpack_public_path__ + "static/media/icon128.9da500f0.png";